import axios from 'axios'
import Validation from '../../../data/validation/validation'
import { EmailValidationRule } from '../../../data/validation/rules'
import { ScrollIntoFirstError } from '../../../utils/UIHelper'
import { API_ENDPOINT } from '../../../config'

const getDefaultState = () => {
    return {
        processing: false,
        tab: 0,
        email: "",
        errors: {},
        showError: false,
        alertError: {},
        flag: {
            type: "",
            text: ""
        }
    }
}

const isValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors
    validation.addValidationRule(EmailValidationRule, instance.state.email, (error) => instance.state.errors.email = error, { allowNull: false, error: "Invalid" })
    let validate = validation.validate()
    let stateUpdate = {
        errors: errors,
        flag: {
            type: validate ? "" : "error",
            text: validate ? "" : "Please fix the fields in red"
        }
    }
    ScrollIntoFirstError(errors)
    instance.setState({
        ...instance.state,
        ...stateUpdate
    })
    return validate
}

const reset = (instance) => {

    instance.setState({
        ...instance.state,
        processing: true
    })

    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/member/forgot-password",
        data: {
            email: instance.state.email
        }
    }).then(response => handleResetResponse(instance, response))
        .catch(error => {
            instance.setState({
                ...instance.state,
                processing: true
            })
            alert(error)
        })
}

const handleResetResponse = (instance, response) => {
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                tab: 1,
                processing: false
            })
            break
        default:
            instance.setState({
                ...instance.state,
                processing: false,
                flag: {
                    type: "error",
                    text: response.data.message
                }
            })
    }
}

const Worker = instance => {
    return {
        getDefaultState: getDefaultState,
        isValid: () => isValid(instance),
        reset: () => reset(instance)
    }
}

export default Worker